import { ModalProps } from "flowbite-react"
import { useTranslation } from "react-i18next"
import Button from "src/components/button/button"
import ModalWrapper from "src/components/modal/modalWrapper"

type DeleteConfirmModalProps = ModalProps & {
   onCancel?: () => void
   onConfirm?: () => void
   title?: string
   confirmText?: string
   cancelText?: string
   children?: React.ReactNode
}

const DeleteConfirmModal = (props: DeleteConfirmModalProps) => {
   const [t] = useTranslation();
   const { onCancel, onConfirm, title, confirmText, cancelText, children, ...restProps } = props;

   return (
      <ModalWrapper
         title={title || t('delete.confirmTitle')}
         theme={{ root: { sizes: { md: 'max-w-[467px]' } } }}
         actions={
            <div className="flex gap-x-4 justify-center w-full">
               <Button
                  className="h-9 min-w-[102px] border text-sm border-primary hover:bg-tertiary hover:text-white text-primary"
                  outline
                  onClick={onCancel}
               >
                  {cancelText || t('delete.cancel')}
               </Button>
               <Button className="h-9 min-w-[102px] text-sm" onClick={onConfirm}>
                  {confirmText || t('delete.confirm')}
               </Button>
            </div>
         }
         {...restProps}
         onClose={onCancel}
      >
         {children || <p className="text-lg font-semibold text-center">Are you sure you want to delete this item?</p>}
      </ModalWrapper>
   )
}

export default DeleteConfirmModal
